import React from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'lodash';

import { Form } from 'react-bootstrap-5';
import ManagedInput from 'components/form/managed_input';
export default class TextInputPair extends React.Component {
  static propTypes = {
    ...Form.Control.propTypes,
    inputRange: PropTypes.arrayOf(PropTypes.number),
    label: PropTypes.string,
    managedInputProps: PropTypes.object,
    maxKey: PropTypes.string,
    maxValue: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    minKey: PropTypes.string,
    minValue: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    name: PropTypes.string,
    type: PropTypes.string,
    onChange: PropTypes.func.isRequired
  };

  static defaultProps = {
    inputRange: [],
    name: '',
    type: 'text'
  }

  state = {
    minError: false,
    maxError: false,
    minHelperText: null,
    maxHelperText: null
  };

  clearHelperText = () => this.setState({
    minHelperText: null,
    maxHelperText: null,
    minError: false,
    maxError: false
  });

  validateMinValue = (value) => {
    if (!isNil(value) && !isNil(this.props.maxValue) && value > this.props.maxValue) {
      this.setState({ minHelperText: 'Cannot be greater than max', maxHelperText: null, minError: true });
    } else {
      this.clearHelperText();
    }
  }

  validateMaxValue = (value) => {
    if (!isNil(value) && !isNil(this.props.minValue) && value < this.props.minValue) {
      this.setState({ maxHelperText: 'Cannot be smaller than min', minHelperText: null, maxError: true });
    } else {
      this.clearHelperText();
    }
  }

  handleMinChange = (value) => {
    const { minKey } = this.props;
    this.validateMinValue(value);
    this.props.onChange(value, minKey);
  };

  handleMaxChange = (value) => {
    const { maxKey } = this.props;
    this.validateMaxValue(value);

    this.props.onChange(value, maxKey);
  };


  render() {
    const { label } = this.props;

    return (
      <Form.Group className="form-group">
        {label && <Form.Label>{label}</Form.Label>}
        <div className="d-flex align-items-center">
          {this.renderMinValue()}
          <div>
            <strong className="mx-3"> TO </strong>
          </div>
          {this.renderMaxValue()}
        </div>
      </Form.Group>
    );
  }

  renderMinValue() {
    const { name, type, minValue, inputRange, managedInputProps } = this.props;
    return (
      <ManagedInput
        addValidationsWrapper={true}
        className="flex-grow-1 form-control"
        error={this.state.minError}
        helperText={this.state.minHelperText}
        maxValue={inputRange[1]}
        minValue={inputRange[0]}
        name={`min${name}`}
        placeholder="Min"
        type={type}
        value={minValue}
        onValueChange={this.handleMinChange}
        {...managedInputProps}
      />
    );
  }

  renderMaxValue() {
    const { name, type, maxValue, inputRange, managedInputProps } = this.props;

    return (
      <ManagedInput
        addValidationsWrapper={true}
        className="flex-grow-1 form-control"
        error={this.state.maxError}
        helperText={this.state.maxHelperText}
        maxValue={inputRange[1]}
        minValue={inputRange[0]}
        name={`max${name}`}
        placeholder="Max"
        type={type}
        value={maxValue}
        onValueChange={this.handleMaxChange}
        {...managedInputProps}
      />
    );
  }
}
